import request from '../../request';
import { jobUrls } from '../../data/locales';

export default function getJobs(variables = {}) {
  return request(`
    query getJobs (
      $locales: [String!],
      $limit: Int,
      $offset: Int,
      $keywords: String,
      $category: String,
      $profileId: String,
      $city: String,
      $highlightLocale: String,
      $highlightType: HighlightPeriodType
    ) {
        jobs (
          locales: $locales,
          limit: $limit,
          offset: $offset,
          keywords: $keywords,
          category: $category,
          profileId: $profileId,
          city: $city,
          highlightLocale: $highlightLocale,
          highlightType: $highlightType
        ) {
          id
          title
          locales
          country
          teaser
          applyForm
          applyUrl
          description
          city
          publishedAt
          expiresAt
          company {
            name
            displayName
            logoUrls(configurations: [
              { width: 42, quality: 10 },
              { width: 300 }, # Logo | mobile/desktop * 1
              { width: 600 }, # Logo | desktop (retina) * 2
              { width: 900 }, # Logo | mobile (moto) * 3
            ])
            description
          }
          template {
            id
            sourceName
            revision
          }
          profiles {
            id
            page {
              slug
              title
              imageUrls(configurations: [{width: 42, quality: 10}, {}])
              mobileImageUrls(configurations: [{width: 42, quality: 10}, {}])
            }
          }
          mergedProperties {
            imageUrls(configurations: [
              { width: 42, quality: 10 },
              { width: 200 }, # Icon | mobile (moto) * 3
              { width: 314 }, # Header | mobile * 1
              { width: 600 }, # Logo | desktop (retina) * 2
              { width: 942 }, # Header | mobile (moto) * 3
              { width: 1752 }, # Header | desktop (retina) * 2
            ])
            name
            type
            value
          }
          urls {
            ${jobUrls}
          }
          applyUrls {
            ${jobUrls}
          }
        }
      }
  `, variables);
}
